<h2 mat-dialog-title>{{action}}</h2>


<div mat-dialog-actions class="p-24 p-t-0">
  <button mat-flat-button (click)="doAction()" color="primary">
    {{action}}
  </button>
  <button mat-stroked-button color="warn" (click)="closeDialog()">
    Cancel
  </button>
</div>
